import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/3cc9acc7-e20e-44a9-9a81-589532e93362";
export const REGISTER_URL = "https://a.ntrk2.com/a21e63c6-992d-44c9-b485-658db487934d";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://cashcopp.loadprkw2a.com/download?openExternalBrowser=1&id=rp4iw979isp2wjz";

export * from "./codes";
export * from "./context";
